// Numbered editorial section header: salmon kicker · divider rule · serif title.
export function SectionLabel({
  kicker,
  title,
}: {
  kicker: string;
  title: string;
}) {
  return (
    <div className="flex items-baseline gap-4 mb-6">
      <span className="text-sm font-bold uppercase tracking-[0.25em] text-salmon">
        {kicker}
      </span>
      <span className="flex-1 h-px bg-ink/15" />
      <h2 className="font-serif text-3xl md:text-4xl tracking-tight">
        {title}
      </h2>
    </div>
  );
}
